import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 
  process.env.REACT_APP_SUPABASE_URL || 
  process.env.VITE_SUPABASE_URL || 
  'https://gtadcpfvuoqnminbxvvd.supabase.co';

const supabaseAnonKey = 
  process.env.REACT_APP_SUPABASE_ANON_KEY || 
  process.env.VITE_SUPABASE_ANON_KEY || 
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd0YWRjcGZ2dW9xbm1pbmJ4dnZkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg5OTQyMjYsImV4cCI6MjA4NDU3MDIyNn0.CArZwF7qIsTBZqoqfJBqofwf0FbNwZjSZjbb-PR94Ts';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
